import type { SliceState } from 'interfaces';
import type { ServerCategoryInventoryItem } from '../../hooks/InventoryHooks/useCategoryInventory';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: CategorySliceState = {
  loading: 'idle',
  categories: {},
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategoryInventoryLoading(state, { payload }: PayloadAction<CategorySliceState['loading']>) {
      state.loading = payload;
    },
    addCategory(
      state,
      { payload }: PayloadAction<Pick<ServerCategoryInventoryItem, 'ProductCode' | 'ProductImage' | 'ProductName'>>,
    ) {
      const { ProductCode: id, ProductName: name, ProductImage: imageUrl } = payload;
      const category: Category = {
        id,
        name,
        imageUrl,
      };
      state.categories[id] = category;
    },
  },
});

const { actions, reducer } = categoriesSlice;

export const { addCategory } = actions;

export default reducer;
export interface Category {
  id: string;
  name: string;
  imageUrl: string;
}

export type CategorySliceState = SliceState<'categories', Category>;
